/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';

const FormContentContext = React.createContext();

export const useFormContentProvider = () => useContext(FormContentContext);

export function FormContentProvider({
  children,
  values,
}) {
  return (
    <FormContentContext.Provider value={values}>
      {children}
    </FormContentContext.Provider>
  );
}

FormContentProvider.propTypes = {
  children: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};
